import React, { ReactNode } from 'react';
import { withRouter } from 'react-router';
import { WprBaseRouteViewComponent } from '../../wpr-framework/view/component/WprBaseRouteViewComponent';
import { HeaderComponent } from '../common/header/HeaderComponent';
import { FooterComponent } from '../common/footer/FooterComponent';
import { PaymentErrorComponentView } from './PaymentErrorComponentView';

/**
 * メール送信完了コンポーネント
 */
class PaymentErrorComponent extends WprBaseRouteViewComponent {
	// コンストラクタ  -----------------------------------------------------------
	constructor(props: any) {
		super(new PaymentErrorComponentView(), props);
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
     * 描画
     */
	public onRender(): ReactNode {
		return (
			<>
				<HeaderComponent />
				<br></br>
				<br></br>
				<br></br>
				<br></br>
				<br></br>
				<br></br>
				<br></br>
				<FooterComponent />
			</>
		);
	}
	// --------------------------------------------------------------------------
}

export default withRouter(PaymentErrorComponent);